import {GetterTree} from "vuex";
import {ModerationTemplatesState} from "@/store/user_management/template_moderation/types";
import {RootState} from "@/store/types";

export const getters:GetterTree<ModerationTemplatesState, RootState> = {
  moderationTemplates: state => state.moderationTemplates ?? [],
}